export enum IFavoriteApi {
    add = '/api/estate-favorite/add',
    remove = '/api/estate-favorite/remove'
}

export interface IFavoriteResponseData {
    data: {
        quantity: number;
    };
    message: string[];
    success: boolean;
}
